import React from 'react';
import "../styles/global.css";

function EventDetails ({ title, description, date, location }) {
    return (
        <div className='event-details-container'>
            <p className="event-title">{title}</p>
            <p className="event-date">{date}</p>
            <p className="event-description">{description}</p>
            <p className='event-sep-sign'>~</p> 
            <p className="event-location">{location}</p>
        </div>
    );
};

export default EventDetails;